/**
 * Categories Field with Advanced Category Management Functionality
 *
 * @author Paige Ponzeka (pponzeka@yext.com)
 */
goog.module('yext.location.categories.CategoryField');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const AdvancedCategoryDialog = goog.require('yext.location.categories.AdvancedCategoryDialog');
const Categories = goog.require('yext.location.categories.Categories');

/**
 * CategoryField
 * @constructor
 */
const CategoryField = function($ctxt, earlyInitializeDialog) {
  this.$ctxt = $ctxt;
  this.$field = $ctxt.find('.js-categories-field');
  this.$link = this.$ctxt.find('.js-show-advanced-category-management');
  this.entityTypeId = this.$field.data('entityTypeId');
  this.earlyInitializeDialog = earlyInitializeDialog || false;

  this.advancedCategoryDialog = null;
  this.baseCategories = this.createBaseCategories($ctxt);

  if (this.$link.length) {
    this.advancedCategoryDialog = this.createAdvancedCategoryDialog();
  }

  this.bindEvents();
};

CategoryField.prototype.createBaseCategories = function() {
  var options = {};
  if (yext.location.info.hasOnlyBasicLocations) {
    options.maxListSize = 1;
  }
  return new Categories(this.$ctxt, options);
};

/**
 * If the advanced categories link is present, initialize the dialog when
 * clicked
 * @param {!jQuery} $element the jQuery container for the Categories code
 * @return {AdvancedCategoryDialog} an initialized dialog
 */
CategoryField.prototype.createAdvancedCategoryDialog = function() {
  var self = this;
  var route = this.$field.data('advancedCategoriesRoute');

  var advancedDialog = new AdvancedCategoryDialog({
    field: this.$ctxt,
    link: this.$link,
    route: route,
    countryCodes: this.baseCategories.countryCodes,
    entityTypeId: this.entityTypeId,
    earlyInitializeDialog: this.earlyInitializeDialog,
  });

  if (advancedDialog) {
    $(advancedDialog).on('updated', function() {
      $(self.categories).trigger('updated');
      var acmBase = advancedDialog.getBaseCategories();
      self.baseCategories.reconcile(acmBase.getData());
      self.setFieldData();
    });

    $(advancedDialog).on('open', function() {
      var acmBase = advancedDialog.getBaseCategories();
      acmBase.reconcile(self.baseCategories.getData());
      // update the base category count
      advancedDialog.onDetailsUpdate(advancedDialog.detailsByCategoryListId[advancedDialog.baseCategoriesListId]);
    });
  }

  return advancedDialog;
};

/**
 * Gets Data from the advancedCategoryDialog
 * @return {!Object} Data from the categories and advanced categories
 */
CategoryField.prototype.getData = function() {
  var field = this.baseCategories.getData();

  if (this.advancedCategoryDialog) {
    field.overrideCategories = this.advancedCategoryDialog.get();
  }
  return field;
};

/**
 * Set the field data to the fieldContainer
 */
CategoryField.prototype.setFieldData = function() {
  this.baseCategories.$fieldData.val(yext.JSON.stringify(this.getData()));
};

/**
 * Calls the function to reset the state of the AdvancedCategoryDialog
 */
CategoryField.prototype.reset = function() {
  this.baseCategories.reset();
  if (this.advancedCategoryDialog && this.advancedCategoryDialog.initialized) {
    this.advancedCategoryDialog.reset();
  }
};

/**
 * Trigger events when advanced categories or base categories are updated
 */
CategoryField.prototype.bindEvents = function() {
  var self = this;

  $(this.baseCategories).on('updated', function() {
    $(self).trigger('updated');
  });

  $(this.advancedCategoryDialog).on('updated', function() {
    $(self).trigger('updated');
  });
};

/**
 * Reconcile base category list along with all other publishers if advanced categories
 * is enabled and initialized
 *
 * @param {!Object} field Serialized CategoriesView object
 */
CategoryField.prototype.reconcile = function(field) {
  this.baseCategories.reconcile(field);
  if (this.advancedCategoryDialog && this.advancedCategoryDialog.initialized) {
    this.advancedCategoryDialog.reconcile(field);
  }
};

/**
 * Store the values of all category lists
 */
CategoryField.prototype.storeValues = function() {
  this.baseCategories.storeValues();
  if (this.advancedCategoryDialog && this.advancedCategoryDialog.initialized) {
    this.advancedCategoryDialog.storeValues();
  }
};

/**
 * @return {number} The primary category id, if there is one
 */
CategoryField.prototype.getPrimaryCategoryId = function() {
  return this.baseCategories.getPrimaryCategoryId();
};

exports = CategoryField;
